import { useMemo } from 'react';
export function useRicosTheme(customTheme) {
    return useMemo(()=>({
            colorPalette: {
                format: 'rgbTuple',
                bgColor: 'var(--wix-forms-formInputBackgroundColor)',
                textColor: 'var(--wix-forms-formParagraphColor)',
                accent1: 'var(--wix-forms-formLinkColor)'
            },
            ...customTheme
        }), [
        customTheme
    ]);
}
export const getHeaderAndParagraphCustomStylesWUT = ()=>{
    return {
        h1: {
            fontSize: 'var(--wix-forms-formHeaderOneFont-size, 28px)',
            fontFamily: 'var(--wix-forms-formHeaderOneFont-family)',
            color: 'rgb(var(--wix-forms-formHeaderOneColor, 0,0,0))'
        },
        h2: {
            fontSize: 'var(--wix-forms-formHeaderTwoFont-size, 20px)',
            fontFamily: 'var(--wix-forms-formHeaderTwoFont-family)',
            color: 'rgb(var(--wix-forms-formHeaderTwoColor, 0,0,0))'
        },
        p: {
            fontSize: 'var(--wix-forms-formParagraphFont-size, 16px)',
            fontFamily: 'var(--wix-forms-formParagraphFont-family)',
            color: 'rgb(var(--wix-forms-formParagraphColor, 0,0,0))'
        }
    };
};
export const getHeaderVariantCustomStylesWUT = ()=>{
    return {
        h1: {
            fontSize: 'var(--wix-forms-formHeaderOneFont-size, 28px)',
            fontFamily: 'var(--wix-forms-formHeaderOneFont-family)',
            color: 'rgb(var(--wix-forms-formHeaderOneColor, 0,0,0))'
        },
        h2: {
            fontSize: 'var(--wix-forms-formHeaderTwoFont-size, 20px)',
            fontFamily: 'var(--wix-forms-formHeaderTwoFont-family)',
            color: 'rgb(var(--wix-forms-formHeaderTwoColor, 0,0,0))'
        },
        h3: {
            fontSize: 'var(--wix-forms-formHeaderThreeFont-size, 18px)',
            fontFamily: 'var(--wix-forms-formHeaderThreeFont-family)',
            color: 'rgb(var(--wix-forms-formHeaderThreeColor, 0,0,0))'
        },
        h4: {
            fontSize: 'var(--wix-forms-formHeaderFourFont-size, 16px)',
            fontFamily: 'var(--wix-forms-formHeaderFourFont-family)',
            color: 'rgb(var(--wix-forms-formHeaderFourColor, 0,0,0))'
        },
        h5: {
            fontSize: 'var(--wix-forms-formHeaderFiveFont-size, 14px)',
            fontFamily: 'var(--wix-forms-formHeaderFiveFont-family)',
            color: 'rgb(var(--wix-forms-formHeaderFiveColor, 0,0,0))'
        },
        h6: {
            fontSize: 'var(--wix-forms-formHeaderSixFont-size, 12px)',
            fontFamily: 'var(--wix-forms-formHeaderSixFont-family)',
            color: 'rgb(var(--wix-forms-formHeaderSixColor, 0,0,0))'
        }
    };
};
export const getRicosPaletteWDS = ()=>{
    const textColor = '#000624';
    const accent1 = '#116DFF';
    return {
        format: 'color',
        textColor,
        accent1
    };
};
export const getHeaderAndParagraphCustomStylesWDS = ()=>{
    const fallback = `Madefor,"Helvetica Neue",Helvetica,Arial,"meiryo","hiragino kaku gothic pro", sans-serif`;
    const headingFontFamily = `var(--wds-font-family-display, var(--wds-font-family-default, var(--wsr-font-family, ${fallback})))`;
    const bodyFontFamily = `var(--wds-font-family-default, var(--wsr-font-family, ${fallback}))`;
    const color = 'var(--wds-color-text-standard-primary, var(--wsr-color-D10, #162D3D))';
    return {
        h1: {
            fontSize: `var(--wds-font-size-heading-1, var(--wsr-heading-font-size-xl, 28px))`,
            fontFamily: headingFontFamily,
            color
        },
        h2: {
            fontSize: `var(--wds-font-size-heading-2, var(--wsr-heading-font-size-l, 21px))`,
            fontFamily: headingFontFamily,
            color
        },
        p: {
            fontSize: `var(--wds-font-size-body-medium, var(--wsr-text-font-size-medium, 16px))`,
            fontFamily: bodyFontFamily,
            color
        }
    };
};
export const getRicosPaletteRAC = ()=>{
    return {
        format: 'color',
        textColor: 'var(--wst-paragraph-2-color, #000000)',
        accent1: 'var(--wst-links-and-actions-color, #116dff)'
    };
};
export const getHeaderAndParagraphCustomStylesRAC = ()=>{
    return {
        h1: {
            fontSize: 'var(--wst-heading-1-font-size, 28px)',
            fontFamily: 'var(--wst-heading-1-font-family)',
            color: 'var(--wst-heading-1-color, #000000)'
        },
        h2: {
            fontSize: 'var(--wst-heading-2-font-size, 20px)',
            fontFamily: 'var(--wst-heading-2-font-family)',
            color: 'var(--wst-heading-2-color, #000000)'
        },
        p: {
            fontSize: 'var(--wst-paragraph-2-font-size, 16px)',
            fontFamily: 'var(--wst-paragraph-2-font-family)',
            color: 'var(--wst-paragraph-2-color, #000000)'
        }
    };
};
export const getHeaderVariantCustomStylesRAC = ()=>{
    return {
        h1: {
            fontSize: 'var(--wst-heading-1-font-size, 50px)',
            fontFamily: 'var(--wst-heading-1-font-family)',
            color: 'var(--wst-heading-1-color, #000000)'
        },
        h2: {
            fontSize: 'var(--wst-heading-2-font-size, 42px)',
            fontFamily: 'var(--wst-heading-2-font-family)',
            color: 'var(--wst-heading-2-color, #000000)'
        },
        h3: {
            fontSize: 'var(--wst-heading-3-font-size, 38px)',
            fontFamily: 'var(--wst-heading-3-font-family)',
            color: 'var(--wst-heading-3-color, #000000)'
        },
        h4: {
            fontSize: 'var(--wst-heading-4-font-size, 34px)',
            fontFamily: 'var(--wst-heading-4-font-family)',
            color: 'var(--wst-heading-4-color, #000000)'
        },
        h5: {
            fontSize: 'var(--wst-heading-5-font-size, 28px)',
            fontFamily: 'var(--wst-heading-5-font-family)',
            color: 'var(--wst-heading-5-color, #000000)'
        },
        h6: {
            fontSize: 'var(--wst-heading-6-font-size, 22px)',
            fontFamily: 'var(--wst-heading-6-font-family)',
            color: 'var(--wst-heading-6-color, #000000)'
        }
    };
};
export const getHeaderVariantCustomStylesWDS = ()=>{
    const fallback = `Madefor,"Helvetica Neue",Helvetica,Arial,"meiryo","hiragino kaku gothic pro", sans-serif`;
    const headingFontFamily = `var(--wds-font-family-display, var(--wds-font-family-default, var(--wsr-font-family, ${fallback})))`;
    const color = 'var(--wds-color-text-standard-primary, var(--wsr-color-D10, #162D3D))';
    return {
        h1: {
            fontSize: `var(--wds-font-size-heading-1, var(--wsr-heading-font-size-xl, 50px))`,
            fontFamily: headingFontFamily,
            color
        },
        h2: {
            fontSize: `var(--wds-font-size-heading-2, var(--wsr-heading-font-size-l, 42px))`,
            fontFamily: headingFontFamily,
            color
        },
        h3: {
            fontSize: `var(--wds-font-size-heading-3, var(--wsr-heading-font-size-m, 38px))`,
            fontFamily: headingFontFamily,
            color
        },
        h4: {
            fontSize: `var(--wds-font-size-heading-4, var(--wsr-heading-font-size-s, 34px))`,
            fontFamily: headingFontFamily,
            color
        },
        h5: {
            fontSize: `var(--wds-font-size-heading-5, var(--wsr-heading-font-size-xs, 28px))`,
            fontFamily: headingFontFamily,
            color
        },
        h6: {
            fontSize: `var(--wds-font-size-heading-6, var(--wsr-heading-font-size-2xs, 22px))`,
            fontFamily: headingFontFamily,
            color
        }
    };
};

//# sourceMappingURL=ricos-theme-utils.js.map